import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminSortIcon = (props: IconProps) => (
  <Icon width="10px" height="16px" viewBox="0 0 10 16" {...props}>
    <path d="M1.844 6h8.281a.854.854 0 0 0 .594-1.469L6.594.281A.77.77 0 0 0 6 0a.833.833 0 0 0-.625.281L1.25 4.531A.854.854 0 0 0 1.844 6Zm8.281 2H1.844c-.75 0-1.157.938-.594 1.5l4.125 4.25c.156.188.375.25.625.25.219 0 .438-.063.594-.25l4.125-4.25c.562-.563.156-1.5-.594-1.5Z" />
  </Icon>
);

export default memo(AdminSortIcon);
